module.exports = __webpack_public_path__ + "static/media/happy-animation.6717ca97.webm";